import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";
import Imgcross from '../../assets/img/cross.png';
import Register from './Register';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import toast, { Toaster } from 'react-hot-toast';
import { internalIpV4 } from '../../services/getIp';
import apiPath from "../../constants/apiPath";
import Http from "../../services/Http";
import { ValidationForm, TextInput, TextInputGroup, FileInput, SelectGroup, Checkbox } from "react-bootstrap4-form-validation";
import validator from 'validator'
import LocalizedStrings from 'react-localization';
import localization from '../../localization';
import { userLogin } from "../../actions/index";
import { connect } from "react-redux";
import ForgotPassword from './ForgotPassword';
import OtpVerify from '../Modal/OtpVerify';
import eyeSvgrepoCom from "../../assets/img/eye-svgrepo-com.svg";
import eyeOffSvgrepoCom from "../../assets/img/eye-off-svgrepo-com.svg";
let strings = new LocalizedStrings(localization);
const mapStateToProps = state => {
    return { user: state.user };

};

const mapDispatchToProps = dispatch => {
    return {
        userLogin: user => dispatch(userLogin(user))
    };
};
const Login = (Props) => {


    const [showLogin, setShowLogin] = useState(false);
    const [showRegister, setShowRegister] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showOtp, setShowOtp] = useState(false);
    const [loginStep, setLoginStep] = useState('email');
    const [loginEmail, setLoginEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const submitLock = useRef(false);

    const [getLogin, setLogin] = useState({
        phone: "",
    });

    const [currentLang, setCurrentLang] = useState(
        localStorage.getItem("current_lang")
            ? localStorage.getItem("current_lang")
            : "en"
    );
    strings.setLanguage(currentLang);
    const formRef = React.createRef();

    const loginClose = () => {
        setShowLogin(false);
        if (Props.onClose) {
            Props.onClose();
        }
    };

    const [getRegister, setRegister] = useState({
        email: '',
    });
    const openRegister = () => {
        setShowLogin(false);
        setShowRegister(true);
    }

    const openForgetPassword = () => {
        // alert("hello");
        setShowLogin(false);
        setShowPassword(true);
        // setShowRegister(true);
    }
    const [passwordType, setPasswordType] = useState("password");
    const [passwordInput, setPasswordInput] = useState("");
    const handlePasswordChange = (evnt) => {
        setPasswordInput(evnt.target.value);
    }
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const loginSubmit = async (e, formData, inputs) => {
        e.preventDefault();
        if (submitLock.current || !validate()) {
            return;
        }

        submitLock.current = true;
        setIsSubmitting(true);
        try {
            var data = new FormData();
            data.append('device_type', 'Website');
            data.append('device_token', await internalIpV4());
            data.append('email', loginStep === 'email' ? formData.email : loginEmail);

            if (loginStep === 'email') {
                let options = {
                    method: 'POST',
                    data: data
                }
                let result = await Http(apiPath.loginEmail, options);
                if (result.status === 200 && result.data.status) {
                    const email = result.data.data.email;
                    setLoginEmail(email);

                    if (result.data.data.account_exists) {
                        setLoginStep('password');
                    } else {
                        setRegister({ email: email });
                        setShowOtp(true);
                        setShowLogin(false);
                        toast.success(result.data.message);
                    }
                } else {
                    // API errors come back as HTTP 200 with status:false and a real
                    // message — show that, not the HTTP statusText ("OK").
                    toast.error(result.data?.message || result.statusText || 'Something went wrong');
                }
                return;
            }

            data.append('password', formData.password);
            let options = {
                method: 'POST',
                data: data
            }
            let result = await Http(apiPath.login, options);
            if (result.status === 200) {
                if (result.data.status == true) {
                    setShowLogin(false);
                    Props.userLogin(result.data.data);
                    toast.success(result.data.message);
                    window.location.reload();
                }
                else {
                    toast.error(result.data.message);
                }
            } else {
                if(result.statusText != null) {
                    toast.error(result?.data?.message || result.statusText);
                }
            }
        } finally {
            submitLock.current = false;
            setIsSubmitting(false);
        }
    }
    const validate = () => {
        let isValid = true;
        return isValid;
    }
    const loginErrorSubmit = (e, formData, inputs) => {
        e.preventDefault();
    }

    useEffect(() => {
        setShowLogin(Props.data);
    }, [Props]);
    return (
        <>
            {showPassword ? <ForgotPassword data={showPassword} /> : ''}
            {showRegister ? <Register data={showRegister} /> : ''}
            {showOtp ? <OtpVerify data={showOtp} userData={getRegister} /> : ''}
            <Modal show={showLogin} onHide={loginClose} animation={true} size="lg" backdrop="static" keyboard={false} centered>
                <Modal.Header >
                    <h5 className="modal-title" id="exampleModalLabel">{strings.sign_in}</h5>
                    <button type="button" className="btn-close" onClick={loginClose}>
                        <img src={Imgcross} alt='Close' />
                    </button>
                </Modal.Header>
                <Modal.Body className='modal-body'>
                    <ValidationForm onSubmit={loginSubmit} onErrorSubmit={loginErrorSubmit} ref={formRef} >
                        <div className="popup-cont">
                            <Form.Group className="form-group" controlId="form-group">
                                <Form.Label>{strings.enter_email}</Form.Label>
                                {loginStep === 'email' ? (
                                    <TextInputGroup type="email" placeholder={strings.enter_email} name="email" required />
                                ) : (
                                    <Form.Control type="email" value={loginEmail} disabled />
                                )}
                            </Form.Group>
                            {loginStep === 'password' && (
                                <Form.Group className="form-group position-relative">
                                    <Form.Label>Enter Password</Form.Label>
                                    <TextInputGroup type={passwordType} name="password" onChange={handlePasswordChange} value={passwordInput} placeholder="Password" required />
                                    <div className="input-group-btn passShowHideBtn position-absolute">
                                        {passwordType === "password" ? <img alt='On' className='w-100' src={eyeSvgrepoCom} onClick={togglePassword} /> : <img alt='Off' className='w-100' src={eyeOffSvgrepoCom} onClick={togglePassword} />}
                                    </div>
                                </Form.Group>
                            )}

                            <div className="login-btn">
                                <Button type="submit" className="btn btn_primary" disabled={isSubmitting} aria-busy={isSubmitting}>
                                    {isSubmitting && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                                    {loginStep === 'email' ? strings.continue : strings.sign_in}
                                </Button>
                            </div>
                            <div className="already_cls">
                                {loginStep === 'password' && (
                                    <p><Link to="#" onClick={() => setLoginStep('email')}>Use another email</Link></p>
                                )}
                                <p>{strings.new_account} <Link to="#" onClick={openRegister} >{strings.sign_up}</Link></p>
                                <p><Link to="#" onClick={openForgetPassword} >{strings.forget_password}</Link></p>
                            </div>
                        </div>

                    </ValidationForm>
                </Modal.Body>
            </Modal>



        </>

    )
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);
